module.exports = __webpack_public_path__ + "static/media/logo-kinder-footer.09712c50.png";